export default __webpack_public_path__ + "static/media/spd-hf-img.a1ba59f4.webp";